import axios from "axios";
import { normalizeFormData } from "@/utils/numberConverter";
import { getConfig } from "@/utils/config";
import { clearAuthSession } from "@/utils/auth";

// Get baseURL from runtime config (will use default if config not loaded yet)
const getBaseURL = () => getConfig("VITE_API_BASE_URL", "");

const api = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
});

// Update baseURL when config is loaded (called from main.jsx after config loads)
export function updateApiBaseURL() {
  const newBaseURL = getBaseURL();
  if (newBaseURL) {
    api.defaults.baseURL = newBaseURL;
  } else {
    console.warn('[api] VITE_API_BASE_URL is not set. Please configure config.json.');
  }
}

// Add request interceptor to convert Farsi numbers to English in all form submissions
// and add authentication token to headers
api.interceptors.request.use(
  (config) => {
    // Get authentication token
    const token = localStorage.getItem("auth_token");

    // Set headers
    const headers = {
      Authorization: `Bearer ${token ?? ""}`,
      "Accept-Language": "fa-IR",
    };

    // Merge with existing headers
    config.headers = {
      ...config.headers,
      ...headers,
    };

    // Normalize request data (body) for POST, PUT, PATCH requests
    if (config.data) {
      config.data = normalizeFormData(config.data);
    }

    // Normalize query parameters for GET requests
    if (config.params) {
      config.params = normalizeFormData(config.params);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle blocked users and unauthorized access
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle unauthorized (401) - clear auth and redirect to login
    if (error.response?.status === 401) {
      clearAuthSession({ redirectToLogin: true });
    }

    // Handle forbidden (403) - pending approval
    if (error.response?.status === 403 && error.response?.data?.reason === 'pending_approval') {
      // Don't redirect if on set-password or pending-approval pages (these pages allow blocked users)
      const allowedPaths = ['/pending-approval', '/set-password'];
      const currentPath = window.location.pathname;
      const isOnAllowedPath = allowedPaths.some(path => currentPath.includes(path));

      if (!isOnAllowedPath) {
        window.location.href = '/pending-approval';
      }
    }
    return Promise.reject(error);
  }
);

export default api;


